import { gql } from '@apollo/client'

export const MUTATION_UPGRADE_DEVICE = gql`
  mutation mutationUpgradeDevice($input: UpgradeDeviceCaseItemInput!) {
    upgradeDevice(input: $input) {
      caseItem {
        id
        subCaseItems {
          id
          data {
            deviceDefinition {
              id
              name
            }
            requestedRentCategory {
              deviceDefinition {
                id
              }
            }
          }
        }
      }
    }
  }
`
